import React from 'react';
import cn from 'classnames';

const BWFooter = ({ additionalClass, children }) => (
  <footer data-bem="BWFooter" className={cn('bw-footer-wrapper', 'cfix', additionalClass)}>
    <div>{children}</div>
  </footer>
);

export default BWFooter;
